import { useReducer } from 'react';

export enum PadBusinessType {
  BUSINESS = 'BUSINESS',
  PERSONAL = 'PERSONAL',
}

export interface PadFormState {
  contactInfo: {
    city: string;
    email: string;
    payeeName: string;
    phoneNumber: string;
    postalCode: string;
    province: string;
    street: string;
  };
  padBusinessType: PadBusinessType | null;
  paymentMethod: {
    bankAccountNumber: string;
    bankCode: string;
    bankLocationId: string;
    ownerName: string;
  };
}

export const initialPadFormState: PadFormState = {
  contactInfo: {
    city: '',
    email: '',
    payeeName: '',
    phoneNumber: '',
    postalCode: '',
    province: '',
    street: '',
  },
  padBusinessType: null,
  paymentMethod: {
    bankAccountNumber: '',
    bankCode: '',
    bankLocationId: '',
    ownerName: '',
  },
};

export enum PadPaymentFormActions {
  HYDRATE = 'HYDRATE',
  SET_BUSINESS_TYPE = 'SET_BUSINESS_TYPE',
  SET_CONTACT_FIELD = 'SET_CONTACT_FIELD',
  SET_PAYMENT_METHOD_FIELD = 'SET_PAYMENT_METHOD_FIELD',
}

export type PadPaymentFormAction =
  | {
      payload: { contactInfo: PadFormState['contactInfo'] };
      type: PadPaymentFormActions.HYDRATE;
    }
  | {
      payload: { padBusinessType: PadBusinessType };
      type: PadPaymentFormActions.SET_BUSINESS_TYPE;
    }
  | {
      payload: { field: keyof PadFormState['contactInfo']; value: string };
      type: PadPaymentFormActions.SET_CONTACT_FIELD;
    }
  | {
      payload: { field: keyof PadFormState['paymentMethod']; value: string };
      type: PadPaymentFormActions.SET_PAYMENT_METHOD_FIELD;
    };

const padPaymentFormReducer = (
  state: PadFormState,
  action: PadPaymentFormAction,
): PadFormState => {
  switch (action.type) {
    case PadPaymentFormActions.HYDRATE:
      return {
        ...state,
        contactInfo: action.payload.contactInfo,
      };
    case PadPaymentFormActions.SET_BUSINESS_TYPE:
      return {
        ...state,
        padBusinessType: action.payload.padBusinessType,
      };
    case PadPaymentFormActions.SET_CONTACT_FIELD:
      return {
        ...state,
        contactInfo: {
          ...state.contactInfo,
          [action.payload.field]: action.payload.value,
        },
      };
    case PadPaymentFormActions.SET_PAYMENT_METHOD_FIELD:
      return {
        ...state,
        paymentMethod: {
          ...state.paymentMethod,
          [action.payload.field]: action.payload.value,
        },
      };
    default:
      return initialPadFormState;
  }
};

export const usePadPaymentFormReducer = (
  initialState: PadFormState = initialPadFormState,
) => useReducer(padPaymentFormReducer, initialState);
